import {Checkbox, ConsentLinksText, Typography} from '@sollapay/ui';
import {LEGAL_ROUTES} from '@sollapay/utils';
import {useTranslation} from 'react-i18next';

import type {FC, ReactNode} from 'react';

type TrustAccountConsentFieldsProps = {
  termsAccepted: boolean;
  onTermsAcceptedChange: (checked: boolean) => void;
  marketingConsent: boolean;
  onMarketingConsentChange: (checked: boolean) => void;
};

const TERMS_CHECKBOX_ID = 'trust-account-consent-terms';
const MARKETING_CHECKBOX_ID = 'trust-account-consent-marketing';

export const TrustAccountConsentFields: FC<TrustAccountConsentFieldsProps> = ({
  termsAccepted,
  onTermsAcceptedChange,
  marketingConsent,
  onMarketingConsentChange
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <div className="flex flex-col gap-3">
      <ConsentRow
        id={TERMS_CHECKBOX_ID}
        checked={termsAccepted}
        onCheckedChange={onTermsAcceptedChange}
      >
        <ConsentLinksText
          className="flex-1"
          prefix={t('modal.consent.termsPrefix')}
          termsLabel={t('modal.consent.termsLink')}
          termsHref={LEGAL_ROUTES.termsOfUse}
          connector={t('modal.consent.termsAnd')}
          privacyLabel={t('modal.consent.privacyLink')}
          privacyHref={LEGAL_ROUTES.privacyPolicy}
        />
      </ConsentRow>
      <ConsentRow
        id={MARKETING_CHECKBOX_ID}
        checked={marketingConsent}
        onCheckedChange={onMarketingConsentChange}
      >
        <Typography
          as="span"
          size="xs"
          color="secondary"
          className="flex-1 whitespace-normal text-right"
        >
          {t('modal.consent.marketing')}
        </Typography>
      </ConsentRow>
    </div>
  );
};

interface ConsentRowProps {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  children: ReactNode;
}

const ConsentRow: FC<ConsentRowProps> = ({id, checked, onCheckedChange, children}) => (
  <label htmlFor={id} className="flex w-full cursor-pointer items-start gap-2">
    <Checkbox
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      className="mt-0.5 shrink-0"
    />
    {children}
  </label>
);
